import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { ApplicationState, DispatchType } from '../reducers';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<DispatchType>();
export const useAppSelector: TypedUseSelectorHook<ApplicationState> = useSelector;
